// extracted by mini-css-extract-plugin
module.exports = {"SearchBar__input":"SearchBar_SearchBar__input__1vuTG","SearchBar__icon":"SearchBar_SearchBar__icon__1OKC3"};